import React, { SVGProps } from 'react'
export const FifthDefaultRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M10.083 5.16C7.25 3.124 4.009 2.701 0 2V1c4.074.712 7.658 1.186 10.666 3.348C13.695 6.526 15.753 9.631 16 14c0 6.5-1.709 11.278-4.904 14.69C7.914 32.09 4.5 34 0 35v-1c4.5-1 7.349-2.77 10.366-5.992 3.005-3.21 4.634-7.508 4.636-13.952-.229-4.034-2.108-6.874-4.92-8.896Z"
      clipRule="evenodd"
    />
  </svg>
)
